// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorFault {
  LowerPitSwitch = 0,
  PowerLoss = 1,
  UpperCombImpact = 2,
  Overspeed = 3,
  DoorDoesNotClose = 4,
  StartPermitRelay = 5,
  Overload = 6,
  Drive = 7,
  EmergencyPower = 8,
  Earthquake = 9,
  DoorTimedOutClosing = 10,
  CarNotAvailable = 11,
  DriveNotAvailable = 12,
  DoorTimedOutOpening = 13,
  HallButtonFailureBussFuseBlown = 14,
  CarDelayedExessively = 15,
  DoorOpenAndDoorLockConcurrently = 16,
  OutOfServiceWithDoorLock = 17,
  OutOfServiceWithoutDoorLock = 18,
  LostDoorLockWhileRunning = 19,
  PhotoCellDectector = 20,
  SafetyEdgeFailure = 21,
  HoistwaySafetyCircuitOpen = 22,
  GovernorSwitchOpen = 23,
  CarSafetyCircuitOpen = 24,
  CarTopSwitchOpen = 25,
  CommunicationLoss = 26,
  Reset = 27,
  Position = 28,
  BinaryInput = 29,
  DoorZone = 30,
  Stalled = 31,
  DoorOpen = 32,
  DoorClose = 33,
  Up = 34,
  Down = 35,
  HoistwayLearn = 36,
  StopSwitch = 37,
  DPRInput = 38,
  LcFuseBlown = 39,
  HcFuseBlown = 40,
  PositionInputOff = 41,
  CarSafety = 42,
  UlOrDlOff = 43,
  DeltaOff = 44,
  UtCount = 45,
  Ut1Count = 46,
  Ut2Count = 47,
  Ut3Count = 48,
  DtCount = 49,
  Dt1Count = 50,
  Dt2Count = 51,
  Dt3Count = 52,
  RearDoorOpen = 53,
  RearDoorClose = 54,
  Car1CommLoss = 55,
  Car2CommLoss = 56,
  Car3CommLoss = 57,
  Car4CommLos = 58,
  Car5CommLoss = 59,
  Car6CommLoss = 60,
  RunIoFailedOn = 61,
  RunORunA_I = 62,
  RunIoFailedOff = 63,
  RunAIoFailedOn = 64,
  RunAIoFailedOff = 65,
  UpIoFailedOn = 66,
  UpIoFailedOff = 67,
  DnrIoFailedOn = 68,
  DnrIoFailedOff = 69,
  UpfIoFailedOn = 70,
  UpfIoFailedOff = 71,
  DfIoFailedOn = 72,
  DfIoFailedOff = 73,
  MsIoFailedOn = 74,
  Run0Run1Failed = 75,
  MsIoFailedOff = 76,
  McIoFailedOn = 77,
  McIoFailedOff = 78,
  BrkIoFailedOn = 79,
  BrkIoFailedOff = 80,
  DonIoFailedOff = 81,
  RunA = 82,
  TopDoorLock = 83,
  MidDoorLock = 84,
  BotDoorLock = 85,
  GateSwitch = 86,
  RearTopLock = 87,
  RearMidLock = 88,
  RearBotLock = 89,
  RearGateSwitch = 90,
  PInputOff = 91,
  EmergencyStop = 92,
  InspectionInput = 93,
  GateLockBypassSwitch = 94,
  Grt1InputOn = 95,
  Grt1InputOff = 96,
  Grt2InputOn = 97,
  Grt2InputOff = 98,
  GripperDidNotPick = 99,
  GripperTrip = 100,
  DlTopAndDlTop1Opposite = 101,
  DlMidAndDlMid1Opposite = 102,
  DlBotAndDlBot1Opposite = 103,
  GateSwitchAndGateSwitch1Opposite = 104,
  RlmAndRlm1Opposite = 105,
  RgsAndRgs1Opposite = 106,
  BrakePick = 107,
  BrakeDrop = 108,
  BrakeSetGripper = 109,
  DeltaOn = 110,
  CwtSwitchErrorAtDT = 111,
  CwtSwitchErrorAtUT = 112,
  TargetAtUT = 113,
  TargetAtUT1 = 114,
  TargetAtUT2 = 115,
  TargetAtUt3 = 116,
  TargetAtDT = 117,
  TargetAtDT1 = 118,
  TargetAtDT2 = 119,
  TargetAtDT3 = 120,
  HcComDevice = 121,
  CarComDevice = 122,
  TocCANComm = 123,
  DriveComRecv = 124,
  PowerUpReset = 125,
  PossibleDrv1028Er = 126,
  CarSafePreop = 127,
  CarSafeStart = 128,
  InspectionUpDnSwitch = 129,
  DriveComTrmError = 130,
  DriveComIntError = 131,
  DriveComTxEmptyEr = 132,
  UTSCount = 133,
  DTSCount = 134,
  TargetAtUTS = 135,
  TargetAtDTS = 136,
  DriveCom8259 = 137,
  DriveComTxStopEr = 138,
  SpbCANCom = 139,
  DbrTemperature = 140,
  SebCANCom = 141,
  LwCalibration = 142,
  CANChipInit = 143,
  RunShutdown = 144,
  BadFloorTable = 145,
  CarGateOpen = 146,
  ContactorDropTimer = 147,
  GateLock = 148,
  DerailmentDoorOpen = 149,
  DownDirectionalSwitch = 150,
  NoBalanceComplete = 151,
  CanNotDetermineMode = 152,
  NoRetriesLeft = 153,
  SequenceTimers = 154,
  HoistwaySafetyString = 155,
  SafetyStringOpen = 156,
  UpDirectionalSwitch = 157,
  VelocityNotZero = 158,
  TopNetFeedback = 159,
  BottomNetFeedback = 160,
  DriveSerialLink = 161,
  BrakeFeedbackContact = 162,
  FrontDoorObstruction = 163,
  RearDoorObstruction = 164,
  FrontPhotocell = 165,
  RearPhotocell = 166,
  TimedOutOfService = 167,
  PositionNotKnown = 168,
  DriveShutdown = 169,
  DoorSafetyOpen = 170,
  EmergencyStopOpen = 171,
  SerialNTSError = 172,
  InitFailure = 173,
  CounterWeightDerailed = 174,
  StartProtect = 175,
  Brake = 176,
  Motion = 177,
  FrontDoorFauledToOpenClose = 178,
  RearDoorFailedToOpenClose = 179,
  CarCommunicationLoss = 180,
  NoCommWithMapOrGroup = 181,
  ServiceProtect = 182,
  ShuntTrip = 183,
  EmergencyDispatch = 184,
  UnintendedMotion = 185,
  RescupeOperations = 186,
  RunMonitorFailure = 187,
  Selector = 188,
  FrontHoistDoorWatchdog = 189,
  RearHoistDoorWaatchdog = 190,
  FrontCarDoorWatchdog = 191,
  RearCarDoorWatchdog = 192,
  DiagnosticsCarLockout = 193,
  LowOil = 194,
  Viscosity = 195,
  LoadweigherShutdown = 196,
  CheckedRedundancyShutdown = 197,
  RetirngCamFailure = 198,
  FrontDoorCommLoss = 199,
  RearDoorCommLoss = 200,
  InvalidInspection = 201,
  FloodedPit = 202,
  AttemptedOverspeed = 203,
  B2ContactorOpen = 204,
  BContactorFailed = 205,
  BContactorOpen = 206,
  BelowBottonDZ = 207,
  BothuetAndDets = 208,
  CPUStopSwitch = 209,
  Car7CommLos = 210,
  Car8CommLoss = 211,
  CarBypassSwitch = 212,
  CarLost = 213,
  CarNetwork = 214,
  CheckGSW = 215,
  CheckInterlock = 216,
  ContactorNotClosed = 217,
  CorrectionRun = 218,
  DriveConfiguration = 219,
  DriveNotReady = 220,
  ETSOverspeed = 221,
  ErrorClosingsMRelay = 222,
  ErrorOpoeningsMRelay = 223,
  FaultLogAutoClear = 224,
  FaultsCleared = 225,
  GroupNetwork = 226,
  HallBypassSwitch = 227,
  HallCallNodeError = 228,
  HighSpeedTest = 229,
  InCarStop = 230,
  InvalidContractSpeed = 231,
  InvalidHighSpeed = 232,
  InvalidInspectionSpeed = 233,
  LearnError = 234,
  LostDCL = 235,
  LostGateSwitchOutsideDZ = 236,
  LostSaf = 237,
  LowPressure = 238,
  MContactorFailed = 239,
  MContactorOpen = 240,
  MotorNotUpToSpeed = 241,
  MotorStopFailed = 242,
  MotorTimerLimit = 243,
  OutOfService = 244,
  RedudantAccess = 245,
  RedudantCarBypass = 246,
  RedundanTuets = 247,
  RedundantBottomLock = 248,
  RedundantDets = 249,
  RedundantFireStop = 250,
  RedundantGateSwitch = 251,
  RedundantHallBypass = 252,
  RedundantICStop = 253,
  RedundantInspection = 254,
  RedundantInspic = 255,
  RedundantMiddleLock = 256,
  RedundantRearGateSwitch = 257,
  RedundantTopLock = 258,
  Saf1CloseFailure = 259,
  Saf1OpenFail = 260,
  Saf2CloseFailure = 261,
  Saf2OpenFail = 262,
  SafetyConfiguration = 263,
  SavedConfiguration = 264,
  SpeedDeviationError = 265,
  SpineTCT = 266,
  SpineTMR = 267,
  TedundantInsPmr = 268
}
